import {
  getRuntimePlatform,
  isNativeRuntime,
  type RuntimeClient,
} from "@/clients/runtime.client";

let _runtime: RuntimeClient | undefined;

export const configurePlatformRuntime = (runtime: RuntimeClient): void => {
  _runtime = runtime;
};

export const getPlatformRuntime = (): RuntimeClient => {
  if (!_runtime) throw new Error("Platform runtime has not been configured");
  return _runtime;
};

export const isNativeApp = (): boolean => {
  return isNativeRuntime();
};

export const getPlatform = (): "android" | "ios" | "web" => {
  return getRuntimePlatform();
};
